import {
  compose,
  withPropsOnChange,
} from 'recompose'

import { esuzIssuesApiActions, ESUZ_ISSUES_SCHEMA_NAME } from 'api/esuzIssues'
import prepareEsuzIssueForWidget from './prepareEsuzIssueForWidget'
import { esuzStatusesTransport, esuzStatusesDataPropName } from './esuzStatusesTransport'

export const esuzConfigName = `esuzConfig`

const withEsuzIssueOnSelect = compose(
  esuzStatusesTransport,
  withPropsOnChange([esuzStatusesDataPropName], ({
    [esuzStatusesDataPropName]: esuzStatuses,
  }) => ({
    [esuzConfigName]: {
      valueField       : `id`,
      textField        : `issueNumber`,
      placeholder      : `Начните вводить номер заявки из ЕСУЗ`,
      apiAction        : (params) => esuzIssuesApiActions.fetch({ issueNumberLike: params, limit: 20, offset: 0 }),
      entityName       : ESUZ_ISSUES_SCHEMA_NAME,
      transformLoadData: (data) => prepareEsuzIssueForWidget(data, esuzStatuses),
    },
  }))
)


export default withEsuzIssueOnSelect
